module.exports = __webpack_public_path__ + "static/media/suddivisione-ore.e9e9ac6e.odt";